import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2;

import { makeObservable, observable, runInAction, computed } from "mobx";
import { persist } from "mobx-persist";
var OrderTypeSelectionOptInModel = (_dec = persist("map"), (_class = /*#__PURE__*/function () {
  function OrderTypeSelectionOptInModel(platformUtil) {
    _classCallCheck(this, OrderTypeSelectionOptInModel);

    _defineProperty(this, "platformUtil", void 0);

    _initializerDefineProperty(this, "_isModalShown", _descriptor, this);

    _initializerDefineProperty(this, "_orderTypeOptInMap", _descriptor2, this);

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(OrderTypeSelectionOptInModel, [{
    key: "setIsModalShown",
    value: function setIsModalShown(flag) {
      var _this = this;

      runInAction(function () {
        _this._isModalShown = flag;
      });
    }
  }, {
    key: "orderTypeOptInMap",
    set: function set(value) {
      var _this2 = this;

      runInAction(function () {
        _this2._orderTypeOptInMap = value;
      });
    },
    get: function get() {
      return this._orderTypeOptInMap;
    }
  }, {
    key: "isModalShown",
    get: function get() {
      return this._isModalShown;
    }
  }]);

  return OrderTypeSelectionOptInModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_isModalShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_orderTypeOptInMap", [_dec, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "isModalShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isModalShown"), _class.prototype)), _class));
export { OrderTypeSelectionOptInModel as default };